"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ViewWindow_vue_1 = __importDefault(require("./ViewWindow.vue"));
var vue_class_component_1 = __importStar(require("vue-class-component"));
var DistrictsMixin_1 = __importDefault(require("../mixins/request/DistrictsMixin"));
var UnitsMixin_1 = __importDefault(require("../mixins/request/UnitsMixin"));
var TopMenu_vue_1 = __importDefault(require("./TheScouts/TopMenu.vue"));
var ScoutsMixin_1 = __importDefault(require("../mixins/request/ScoutsMixin"));
var VPagination_vue_1 = __importDefault(require("./scraps/VPagination.vue"));
var ScoutsTable_vue_1 = __importDefault(require("./TheScouts/ScoutsTable.vue"));
var event_bus_1 = require("../event-bus");
var vue_property_decorator_1 = require("vue-property-decorator");
var request_1 = __importDefault(require("../request"));
var VAlert_vue_1 = __importDefault(require("./scraps/VAlert.vue"));
var permissions_json_1 = __importDefault(require("../../permissions.json"));
var PermissionsMixin_1 = __importDefault(require("../mixins/request/PermissionsMixin"));
var VInlineInputEditor_vue_1 = __importDefault(require("./scraps/VInlineInputEditor.vue"));
var TheScouts = /** @class */ (function (_super) {
    __extends(TheScouts, _super);
    function TheScouts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "the-scouts";
        _this.lastModified = "";
        /**
         * Display state - either show contributions statuses or allow to update the contributions.
         */
        _this.displayState = _this.can(permissions_json_1.default.scouts.contributions.update)
            ? "update"
            : "preview";
        return _this;
    }
    TheScouts.prototype.onDistrictsChanged = function (districts) {
        if (districts.array.length === 1) {
            this.currentDistrict = districts.array[0];
            this.lastModified = districts.array[0].last_modified;
        }
    };
    TheScouts.prototype.onCurrentUnitChanged = function (currentUnit) {
        this.requestScouts(1, this.currentDistrict.id, currentUnit.id);
    };
    TheScouts.prototype.archivedChanged = function (archived) {
        if (archived) {
            this.displayState = "preview";
        }
    };
    TheScouts.prototype.created = function () {
        event_bus_1.EventBus.$on(event_bus_1.events.district.change, this.updateCurrentDistrict)
            .$on(event_bus_1.events.unit.change, this.updateCurrentUnit)
            .$on(event_bus_1.events.contribution.update, this.onContributionUpdate)
            .$on(event_bus_1.events.district.last_modified.update, this.updateLastModified)
            .$on(event_bus_1.events.district.last_modified.accept, this.onUpdateLastModified)
            .$on(event_bus_1.events.scout.archived, this.updateArchived)
            .$on(event_bus_1.events.scout.displayState, this.updateDisplayState);
        this.echo.channel(this.echoChannels.contribution)
            .listen(this.echoEvents.contribution.update, this.updateScout);
        this.requestScoutsInitial();
        event_bus_1.EventBus.$emit(event_bus_1.events.common.fullScreenWindow, true);
    };
    TheScouts.prototype.beforeDestroy = function () {
        event_bus_1.EventBus.$off(event_bus_1.events.district.change, this.updateCurrentDistrict)
            .$off(event_bus_1.events.unit.change, this.updateCurrentUnit)
            .$off(event_bus_1.events.contribution.update, this.onContributionUpdate)
            .$off(event_bus_1.events.district.last_modified.update, this.updateLastModified)
            .$off(event_bus_1.events.district.last_modified.accept, this.onUpdateLastModified)
            .$off(event_bus_1.events.scout.archived, this.updateArchived)
            .$off(event_bus_1.events.scout.displayState, this.updateDisplayState);
        this.echo.leave(this.echoChannels.contribution);
        event_bus_1.EventBus.$emit(event_bus_1.events.common.fullScreenWindow, false);
    };
    TheScouts.prototype.requestScoutsInitial = function () {
        var _this = this;
        var _a, _b;
        return request_1.default.scout.initial(this.scouts.search, this.archived, (_a = this.currentDistrict.id) !== null && _a !== void 0 ? _a : 0, (_b = this.currentUnit.id) !== null && _b !== void 0 ? _b : 0, this.scouts.pagination.current_page, function (scouts, pagination, districts, units) {
            _this.updateScouts(scouts, pagination);
            _this.updateDistricts(districts);
            _this.updateUnits(units);
        });
    };
    TheScouts.prototype.requestDistricts = function () {
        return request_1.default.district.all("", -1, this.updateDistricts);
    };
    TheScouts.prototype.requestUnits = function () {
        return request_1.default.unit.all(0, "", -1, this.updateUnits);
    };
    TheScouts.prototype.onContributionUpdate = function (data) {
        return request_1.default.contribution.update(data, this.updateScout);
    };
    TheScouts.prototype.updateCurrentDistrict = function (district) {
        this.currentDistrict = district;
        if (district.id === 0) {
            this.currentUnit = {};
        }
        this.requestUnits();
        this.requestScouts(1, district.id, 0);
    };
    TheScouts.prototype.updateCurrentUnit = function (unit) {
        this.currentUnit = unit;
    };
    TheScouts.prototype.updateDisplayState = function (displayState) {
        this.displayState = displayState
            ? "preview"
            : "update";
    };
    TheScouts.prototype.updateLastModified = function (value) {
        this.lastModified = value;
    };
    TheScouts.prototype.onUpdateLastModified = function () {
        request_1.default.district.updateLastModified(this.currentDistrict.id, this.lastModified, this.updateDistrict);
    };
    __decorate([
        vue_property_decorator_1.Watch("districts")
    ], TheScouts.prototype, "onDistrictsChanged", null);
    __decorate([
        vue_property_decorator_1.Watch("currentUnit")
    ], TheScouts.prototype, "onCurrentUnitChanged", null);
    __decorate([
        vue_property_decorator_1.Watch("archived")
    ], TheScouts.prototype, "archivedChanged", null);
    TheScouts = __decorate([
        vue_class_component_1.default({ components: {
                ViewWindow: ViewWindow_vue_1.default,
                TopMenu: TopMenu_vue_1.default,
                VPagination: VPagination_vue_1.default,
                ScoutsTable: ScoutsTable_vue_1.default,
                VAlert: VAlert_vue_1.default,
                VInlineInputEditor: VInlineInputEditor_vue_1.default
            } })
    ], TheScouts);
    return TheScouts;
}(vue_class_component_1.mixins(PermissionsMixin_1.default, DistrictsMixin_1.default, UnitsMixin_1.default, ScoutsMixin_1.default)));
exports.default = TheScouts;
